import script from "./categoriesView.vue?vue&type=script&setup=true&lang=js"
export * from "./categoriesView.vue?vue&type=script&setup=true&lang=js"

import "./categoriesView.vue?vue&type=style&index=0&id=6b5ec9cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b5ec9cc"]])

export default __exports__